import {
  validateToZero,
  validateForGroundFloor,
  validateSum,
  validateToFields,
  validateNotEqualToInitVal,
  validateToHasPhone,
} from './validators';

const getRequiredRule = (message, type) => ({
  type: type ?? 'string',
  required: true,
  whitespace: true,
  message,
});

const getEmailRule = () => ({
  type: 'email',
  message: 'Укажите корректный email',
});

const getIntegerRule = () => ({
  type: 'integer',
  message: 'Поле принимает только целые числа',
  transform: (val) => {
    if (val && val.trim().length !== 0) {
      const replaceVal = val.replace(',', '.');

      return Number(replaceVal);
    }

    return undefined;
  },
});

const getFractionalRule = () => ({
  type: 'number',
  message: 'Поле принимает только числа',
  transform: (val) => {
    if (val && val.trim().length !== 0) {
      const replaceVal = val.replace(',', '.');

      return Number(replaceVal);
    }

    return undefined;
  },
});

const getNotEqualToInitValRule = (initialValue, numberComparison = false) => ({
  validator: validateNotEqualToInitVal(initialValue, numberComparison),
});

const getGroundFloorRule = (form) => ({
  validator: validateForGroundFloor(form),
});

const getZeroRule = () => ({
  validator: validateToZero,
});

const getSumRule = (form, fieldsName, errMsg) => ({
  validator: validateSum(form, fieldsName, errMsg),
});

const getForceValidateRule = (form, fieldsName) => ({
  validator: validateToFields(form, fieldsName),
});

const getPhoneLengthRule = () => ({
  len: 10,
  message: 'Номер телефона должен включать 10 цифр',
  transform: (val) => (val?.trim().length ? val.replace(/\D/g, '') : ''),
});

const getHasPhoneToBackendRule = () => ({
  validator: validateToHasPhone,
});

export const getInputOptions = ({
  form,
  requiredErrMsg = '',
  fieldType,
  validationTypes = [],
  validateTrigger = [],
  sumFieldsName,
  sumErrMsg,
  forceValidateFieldsName,
  initialValue,
  numberComparison = false,
}) => {
  let options = {};
  let rules = [];

  if (Boolean(requiredErrMsg)) {
    const requiredRule = getRequiredRule(requiredErrMsg, fieldType);

    rules.push(requiredRule);
  }

  validationTypes.forEach((type) => {
    if (type === 'integer') {
      const integerRule = getIntegerRule();

      rules.push(integerRule);
    }

    if (type === 'fractional') {
      const fractionalRule = getFractionalRule();

      rules.push(fractionalRule);
    }

    if (type === 'groundFloor') {
      const groundFloorRule = getGroundFloorRule(form);

      rules.push(groundFloorRule);
    }

    if (type === 'zero') {
      const zeroRule = getZeroRule();

      rules.push(zeroRule);
    }

    if (type === 'sum') {
      const sumRule = getSumRule(form, sumFieldsName, sumErrMsg);

      rules.push(sumRule);
    }

    if (type === 'phoneLength') {
      const phoneLengthRule = getPhoneLengthRule();

      rules.push(phoneLengthRule);
    }

    if (type === 'email') {
      const emailRule = getEmailRule();

      rules.push(emailRule);
    }

    if (type === 'force') {
      const forceValidateRule = getForceValidateRule(
        form,
        forceValidateFieldsName
      );

      rules.push(forceValidateRule);
    }

    if (type === 'notEqualToInitVal') {
      const notEqualToInitVal = getNotEqualToInitValRule(
        initialValue,
        numberComparison
      );

      rules.push(notEqualToInitVal);
    }

    if (type === 'hasPhoneToBackend') {
      const hasPhoneToBackendRule = getHasPhoneToBackendRule();

      rules.push(hasPhoneToBackendRule);
    }
  });

  if (Boolean(validateTrigger.length)) {
    options.validateTrigger = validateTrigger;
  }

  if (Boolean(rules.length)) {
    options.rules = rules;
  }

  if (initialValue) {
    options.initialValue = initialValue;
  }

  return options;
};
